import React from "react";
import { NotificationProps } from "@/features/notification/Notification";
import { DrawerPageRenderer, PortalDrawer } from "./PortalDrawer";
import { Box } from "./BoxSchedule";
import { DrawerPageProps } from "./PortalDrawer/types";
import { SelectedItemProvider } from "./SelectedItemContext";

export type BoxDrawerPageProps = DrawerPageProps & {
  box: Box | undefined;
  nextChargeDate: Date;
};

export interface RootBoxDrawerProps {
  open?: boolean;
  contents?: DrawerPageRenderer;
  onExit: () => void;
  selectedShipment?: Box;
  notify: ({ title, message }: NotificationProps) => void;
  title?: string;
}

export const RootBoxDrawer = ({
  open,
  contents,
  onExit,
  selectedShipment,
  notify,
  title,
}: RootBoxDrawerProps) => {
  return (
    <PortalDrawer
      open={open}
      onExit={onExit}
      notify={notify}
      goToFirstPage={() => {}}
      title={title ? title : "Edit Box"}
      contents={(nav) =>
        contents !== undefined && selectedShipment !== undefined ? (
          <SelectedItemProvider boxItem={selectedShipment.items[0]}>
            {contents({ ...nav })}
          </SelectedItemProvider>
        ) : null
      }
    />
  );
};
